/* Flexipol rebuild: one add-to-basket path for every fx button.
   Uses Dawn's Section Rendering flow so the cart drawer refreshes and opens. */
(function () {
  function addToCart(variantId, quantity, button) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (button) { button.disabled = true; button.dataset.label = button.dataset.label || button.textContent; button.textContent = 'Adding…'; }
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          var item = res.items ? res.items[0] : res;
          drawer.renderContents(Object.assign({}, item, { sections: res.sections }));
        } else {
          window.location.href = '/cart';
        }
        if (button) { button.textContent = 'Added'; button.dataset.state = 'added'; }
        document.dispatchEvent(new CustomEvent('fx:cart-updated'));
      })
      .catch(function (err) {
        if (button) { button.textContent = (err && err.description) ? 'Not available' : 'Try again'; }
      })
      .finally(function () {
        if (button) setTimeout(function () { button.disabled = false; button.textContent = button.dataset.label; delete button.dataset.state; }, 1800);
      });
  }
  window.fxAddToCart = addToCart;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-fx-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form.querySelector('[name="id"]').value, (form.querySelector('[name="quantity"]') || {}).value, form.querySelector('button[type="submit"]'));
  });
})();
